import { render, staticRenderFns } from "./luckydrawlist2.vue?vue&type=template&id=1c98a239&"
import script from "./luckydrawlist2.vue?vue&type=script&lang=js&"
export * from "./luckydrawlist2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports